import { Validator } from "vee-validate";
import { MethodService } from "./serviceModel";

class ServerValidation {
  protected method: MethodService;
  constructor(module, cls, method) {
    this.method = new MethodService(module, cls, method);
  }
  public getMessage(field, params, data) {
    let message = data && data.message;
    return "[" + field + "]:" + message;
  }

  public validate(value, options?: {}): any {
    let args = this.getArgs(value, options);
    return this.getPromise(args);
  }

  protected getArgs(value, options?: {}) {
    return { ...options, value };
  }

  protected getPromise(args) {
    return new Promise(resolve => {
      this.invoke(args).then(res => {
        resolve(res);
      });
    });
  }

  protected async invoke(args: {}) {
    await this.method.invokeAsyn(args);
    let result: IndexObject = {
      valid: this.method.data,
      data: { message: this.method.data ? undefined : "不唯一！" }
    };
    if (!this.method.isSuccess) {
      result.valid = false;
      result.data = { message: this.method.serviceError };
    }
    return result;
  }
}

class UniqueTable extends ServerValidation {
  constructor() {
    super("mes.business.bsc.common", "CommonService", "unique_table");
  }
}

class UniqueKey extends ServerValidation {
  constructor() {
    super("mes.business.bsc.common", "CommonService", "unique_validate");
  }

  public validate(value, options) {
    if (value === options.source) {
      return true;
    }
    delete options.source;
    return this.getPromise(options);
  }
}

let uniqueTable = new UniqueTable();
let uniqueKey = new UniqueKey();

Validator.extend(
  "uniquetable",
  {
    getMessage: uniqueTable.getMessage.bind(uniqueTable),
    validate: uniqueTable.validate.bind(uniqueTable)
  },
  { paramNames: ["db"] }
);
Validator.extend("uniquekey", new UniqueKey(), {
  paramNames: ["db", "table", "column", "source"]
});

// export default unique;
